<script lang="ts" setup>
import UiCardBoxVariant1 from '../UiCardBox/UiCardBoxVariant1/UiCardBoxVariant1.vue'
import type { IProps } from './TextWithBoxes.types'
const props = defineProps<IProps>()

const uiBoxLayout = computed(() => props.layout === 'default' || props.layout === 'layout-2')

</script>

<template>
  <UiSection :color="color">
    <div
      :class="[
        'text-with-boxes',
        `text-with-boxes__${layout}`
      ]"
    >
      <UiHeader
        :header="header"
        :position="position"
      />

      <div
        v-if="text"
        class="text-with-boxes__text"
        v-html="text"
      />

      <div
        v-if="boxes"
        class="text-with-boxes__content"
      >
        <template v-if="uiBoxLayout">
          <UiBox
            v-for="box in boxes"
            :key="box.title"
            :box="box"
          />
        </template>

        <template v-else-if="layout === 'layout-1'">
          <UiCardBox
            v-for="(box, index) in boxes"
            :key="box.title"
            :index="index"
            :box="box"
          />
        </template>

        <template v-else-if="layout === 'layout-3'">
          <UiCardBoxVariant1
            v-for="(box, index) in boxes"
            :key="box.title"
            :index="index"
            :box="box"
          />
        </template>
      </div>

      <div
        v-if="button"
        class="text-with-boxes__buttons"
      >
        <UiButton :to="button.to">
          {{ button.text }}
        </UiButton>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
.text-with-boxes {
  $root: &;

  max-width: 150.4rem;
  margin: 0 auto;

  :deep() {
    .ui-header {
      max-width: 110rem;
      margin: 0 auto;
      text-align: center;
    }
  }

  &__default {
    #{$root}__content {
      .box {
        border: 0.2rem solid #f1f4f3;

        :deep(.box__text) {
          border: none;
        }
      }

      @include atM {
        .box:nth-of-type(2),
        .box:nth-of-type(3) {
          margin-top: 6rem;
        }
      }
    }
  }

  &__layout-1 {
    #{$root}__content {
      flex-direction: column;
      gap: 2.4rem;
      width: 100%;

      @include atXS {
        flex-direction: row;
        flex-wrap: wrap;

        .box {
          width: calc(50% - 1.2rem)
        }
      }

      @include atS {
        gap: 6.4rem;

        .box {
          width: calc(33% - 4rem)
        }
      }
    }

    :deep(.ui-header) {
      max-width: 100%;
      margin: 0;
      text-align: left;
    }
  }

  &__layout-2 {
    max-width: 115rem;

    #{$root}__content {
      .box {
        width: calc(33% - 1.8rem);
        border: 0.2rem solid #f1f4f3;

        :deep(.box__text) {
          border: none;
        }
      }
    }

    @include atM {
      #{$root}__content {
        flex-wrap: wrap;
      }
    }
  }

  &__layout-3 {
    #{$root}__content {
      flex-direction: column;
      width: 100%;
    }

    .box-v1 {
      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-top: 0;
      }
    }

    @include atM {
      #{$root}__content {
        flex-direction: row;
      }

      .box-v1 {
        margin-top: 6.4rem;
      }
    }
  }

  &__text {
    margin-top: 2.4rem;
    font-weight: 500;
    font-size: 2rem;
    line-height: 2.8rem;
    text-align: center;
  }

  &__content {
    display: flex;
    gap: 1.6rem;
    width: calc(100% + 2.4rem);
    margin-top: 3.2rem;
    overflow-x: scroll;
  }

  &__buttons {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 3.2rem;
  }

  @include atM {
    &__text {
      max-width: 110rem;
      margin: 0 auto;
      margin-top: 3.2rem;
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    
    &__content {
      align-items: flex-start;
      gap: 3.2rem;
      width: 100%;
      margin-top: 6.4rem;
      overflow-x: hidden;
    }

    &__buttons {
      margin-top: 7.2rem;
    }
  }
}
</style>
